import React, {Component} from 'react';
import MonthYear from "./MonthYear";
import CalendarNav from "./CalendarNav";
import CalendarDaysHeader from "./CalendarDaysHeader";
import CalendarRowsContainer from "../../containers/CalendarRowsContainer";
import UpdateInfo from "./UpdateInfo";

class CalendarRight extends Component {
  render() {
    return (
      <section className="calendar-right">

        <div className="calendar">

          <section className="calendar-header">

            <MonthYear />

            <CalendarNav />

          </section>

          <UpdateInfo />

          <CalendarDaysHeader/>

          <CalendarRowsContainer/>

        </div>

      </section>
    );
  }
}

export default CalendarRight;
